export default "__VITE_ASSET__CzWpftXi__"